import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  ReactNode,
  useRef,
} from 'react';
import { Tabs, Empty } from 'antd';
import Item from './components/Item';
import { tabType, IProps as ItemType } from './config';
import styles from './index.module.less';
import CheckboxAll from './components/CheckboxAll';
import { CodeSandboxCircleFilled, RightOutlined } from '@ant-design/icons';
import Loading from '../../../Loading';
import { getApi } from './Api';
import { SearchType, SelectType, TabKeyType } from '../../../types';
import { noDataPng } from '../../../assets/images';
const { TabPane } = Tabs;

interface IProps {
  pageId: string;
  tabStyle: any;
  tab: any;
  acKey?: TabKeyType;
  sendSearchGlobal?: boolean;
  keyWord?: string;
  selectList?: SelectType[];
  isSendCheckAll?: boolean;
  maxSelectedNum?: number;
  isSelectUser?: boolean;
  isHasGroups?: boolean;
  deptId?: string;
  isExternalContacts?: boolean;
  tabLoading?: boolean; // 加载tab
  onChangeCheck: (item: any) => void;
  _onCheckAllChange?: (list: any[], check: boolean) => void;
  onvisibleSerch?: (visible?: boolean) => void;
  selectDepartmentTab?: (key: TabKeyType, deptId: string | undefined) => void;
  onClearKeyWord?: () => void;
  isHasDep?: boolean; // 加载tab
  isHasWorkLine?: boolean; // 加载tab
}

interface InitParams {
  key: any;
  _keyWord: string;
  pageIndex?: number;
  depId?: string;
  isInit?: boolean;
}

let laetId: any = 0;
let pageIndex: number = 1;
let flag = false;
export default function Tab(props: IProps) {
  const {
    tabStyle = { height: 'auto' },
    acKey = TabKeyType.RecentlyContact,
    keyWord = '',
    tab = [],
    selectList = [],
    pageId = '',
    maxSelectedNum = -1,
    isSendCheckAll = false,
    sendSearchGlobal = false,
    isSelectUser = false,
    isHasGroups = false,
    isExternalContacts = false,
    isHasDep = false,
    isHasWorkLine = false,
    deptId = '',
    tabLoading = false,
    onChangeCheck,
    _onCheckAllChange,
    onvisibleSerch,
    selectDepartmentTab,
    onClearKeyWord,
  } = props;
  const [activeKey, setActiveKey] = useState(acKey);
  const [list, setList] = useState<ItemType[]>([]); // 全部
  const [breadcrumbDepList, setBreadcrumbDepList] = useState<any[]>([]); // 部门面包屑
  const [loading, setLoading] = useState<boolean>(false);
  const [currentSelectedNum, setCurrentSelectedNum] = useState<number>(0);
  const [hasMoreContacts, setMoreContacts] = useState(false);
  const [hasMoreDepts, setMoreDepts] = useState(false);
  const [hasMoreGroups, setMoreGroups] = useState(false);
  const [newList, setNewList] = useState<ItemType[]>([]);
  const [load, setLoad] = useState<boolean>(false);
  useEffect(() => {
    const disabled =
      maxSelectedNum !== -1 && currentSelectedNum >= maxSelectedNum;
    const _list =
      list?.map((item: ItemType) => {
        item.checked = selectList.some(newItem => newItem.id === item.id);
        item.disabled = !item.checked && disabled;
        return item;
      }) || [];
    setNewList(_list);
  }, [list, maxSelectedNum, currentSelectedNum, selectList]);
  useEffect(() => {
    setCurrentSelectedNum(selectList.length);
  }, [selectList]);

  // 获取数据
  const getListAll = (key: TabKeyType, ope: any) => {
    laetId++;
    return async (theLastId: any) => {
      try {
        const res: any = await getApi[TabKeyType.All](ope);
        flag = false;
        if (laetId !== theLastId) {
          return;
        }
        const { data, hasMoreContacts, hasMoreDepts, hasMoreGroups } = res;
        let newList = data;
        if (key === TabKeyType.All) {
          newList = data?.filter((item: any) => {
            // 外部联系人不显示部门
            if (
              !(isHasWorkLine || isHasDep) &&
              item.type === TabKeyType.Department
            ) {
              return false;
            }
            // 只能选择人，或者不存在组 过滤组  现在isHasGroups有些问题单独传分享有问题
            if (
              !isHasGroups &&
              isSelectUser &&
              item.type === TabKeyType.Groups
            ) {
              return false;
            }
            return true;
          });
        }

        setList((prvList = []) => {
          const list1 = ope.pageNo > 1 ? prvList.concat(newList) : newList;
          console.log(
            'getInitList1112223331',
            ope.pageNo,
            list1,
            prvList?.length,
            newList?.length
          );
          return list1;
        });
        setMoreContacts(hasMoreContacts);
        setMoreDepts(hasMoreDepts);
        setMoreGroups(hasMoreGroups);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
  };
  const getList = (key: TabKeyType, ope: any) => {
    laetId++;
    return async (theLastId: any) => {
      try {
        const tmpKey = sendSearchGlobal ? TabKeyType.All : key;
        const res: any = await getApi[tmpKey](ope);
        flag = false;
        if (laetId !== theLastId) {
          return;
        }
        let newList = res;
        if (key === TabKeyType.Department || key === TabKeyType.WorkLine) {
          newList = res.deptInfoList || [];
        }
        if (key === TabKeyType.Department || key === TabKeyType.WorkLine) {
          setBreadcrumbDepList(res?.breadcrumbList || []);
        }
        if (isSelectUser && key === TabKeyType.RecentlyContact) {
          newList = res?.filter(
            (item: any) => item.type === TabKeyType.Contact
          );
        }
        setList(newList);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
  };
  const getInitList = useCallback(
    (params: InitParams) => {
      const {
        key,
        _keyWord = '',
        pageIndex = 1,
        depId = '',
        isInit = false,
      } = params;

      let ope: any = {
        keyword: _keyWord,
        pageNo: pageIndex,
        pageSize: 15,
        isInit,
      };
      switch (key) {
        case TabKeyType.All:
          ope.pageSize = 3;
          ope.searchType = SearchType.All;
          break;
        case TabKeyType.RecentlyContact:
          ope.pageId = pageId;
          break;
        case TabKeyType.Contact:
          ope.searchType = SearchType.Contacts;
          break;
        case TabKeyType.Department:
          ope.depId = depId || '';
          ope.searchType = SearchType.Department;
          break;
        case TabKeyType.WorkLine:
          ope.depId = depId || '';
          break;
        case TabKeyType.Groups:
          ope.searchType = SearchType.Group;
          break;
      }
      if (sendSearchGlobal) {
        getListAll(key, ope)(laetId);
      } else {
        getList(key, ope)(laetId);
      }
    },
    [sendSearchGlobal, pageId]
  );
  // 全部初始化和keyWord变化调用接口
  useEffect(() => {
    if (sendSearchGlobal && keyWord.length > 0) {
      pageIndex = 1;
      getInitList({ key: activeKey, _keyWord: keyWord, pageIndex });
    }
  }, [keyWord, sendSearchGlobal]);
  useEffect(() => {
    setActiveKey(acKey);
    setLoad(pre => {
      return !pre;
    });
  }, [acKey, deptId]);
  useEffect(() => {
    setLoading(true);
    pageIndex = 1;
    getInitList({
      key: activeKey,
      _keyWord: '',
      pageIndex,
      depId: deptId,
      isInit: true,
    });
  }, [load]);

  // 切换Tab
  const onChangeTab = (key: any) => {
    if (sendSearchGlobal) {
      setActiveKey(key);
      pageIndex = 1;
      setLoading(true);
      getInitList({ key, _keyWord: keyWord, pageIndex, isInit: true });
    } else {
      selectDepartmentTab?.(key, undefined);
    }
  };
  // 分页功能，只有搜索才有
  const onButtom = useCallback(
    (key: TabKeyType, hasMore: boolean) => {
      if (!hasMore || flag) {
        return;
      }
      flag = true;
      pageIndex++;
      getInitList({ key, _keyWord: keyWord, pageIndex });
    },
    [keyWord, activeKey]
  );
  const onCheckAllChange = (val: any) => {
    // const _newList = newList.filter(item => item.type !== TabKeyType.WorkLine);
    const _newList = newList;
    let _list: any = _newList.map((item: any) => {
      item.checked = val;
      return item;
    });
    _onCheckAllChange?.(_list, val);
  };
  const currentLen = useMemo(() => {
    let count = 0;
    for (let item of newList) {
      for (let _item of selectList) {
        if (item.id === _item.id) {
          count++;
        }
      }
    }
    return count;
  }, [newList, selectList]);
  const onChange = useCallback(
    (item: any) => {
      onChangeCheck(item);
    },
    [onChangeCheck]
  );

  const getBreadcrumbList = useCallback(
    async (depId: string) => {
      const isWorkLine = activeKey === TabKeyType.WorkLine;
      let tmpKey = TabKeyType.Department;
      if (isWorkLine) {
        tmpKey = TabKeyType.WorkLine;
      }
      console.log('getBreadcrumbList111', depId);
      //   const res: any = await getApi[tmpKey]({ depId });
      //   setList(res?.deptInfoList || []);
      //   setBreadcrumbDepList(res?.breadcrumbList || []);
      selectDepartmentTab?.(
        isWorkLine ? TabKeyType.WorkLine : TabKeyType.Department,
        depId
      );
    },
    [activeKey]
  );

  const DepaBreadcrumbNav = useMemo(() => {
    return (
      breadcrumbDepList &&
      breadcrumbDepList.map((item: any, index: number) => {
        return (
          <>
            {index !== 0 && (
              <span className={styles['focus-user-selection-org_nav_icon']}>
                <RightOutlined />
              </span>
            )}
            <div
              className={styles['focus-user-selection-org-nav-item']}
              key={index}
            >
              <span
                className={
                  index < breadcrumbDepList.length - 1
                    ? styles['user-selection-item-text active']
                    : styles['user-selection-item-text']
                }
                onClick={() => {
                  if (index === breadcrumbDepList.length - 1) {
                    return;
                  }
                  getBreadcrumbList(item.deptId);
                }}
              >
                {item.deptName}
              </span>
            </div>
          </>
        );
      })
    );
  }, [breadcrumbDepList]);
  const getDepaBreadcrumbNav = useCallback(
    (event, depId = '', isWorkLine?: boolean) => {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      pageIndex = 1;
      if (event?.target?.type !== 'checkbox') {
        if (sendSearchGlobal) {
          onvisibleSerch?.();
          onClearKeyWord?.();
          selectDepartmentTab?.(
            isWorkLine ? TabKeyType.WorkLine : TabKeyType.Department,
            depId
          );
        } else {
          //   let tmpKey = TabKeyType.Department;
          //   if (isWorkLine) {
          //     tmpKey = TabKeyType.WorkLine;
          //   }
          selectDepartmentTab?.(
            isWorkLine ? TabKeyType.WorkLine : TabKeyType.Department,
            depId
          );
        }
      }
    },
    []
  );
  const TabMain = useMemo(() => {
    if (loading) {
      return <Loading size={24}></Loading>;
    }
    // <span className={styles['joyspace-search-nodata']}>输入关键词查找</span> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='暂无数据' style={{ textAlign: 'center', color: '#9B9B9B' }} imageStyle={{ textAlign: 'center', marginTop: '14px' }} />
    const noData =
      sendSearchGlobal && !keyWord ? (
        <span className={styles['joyspace-search-nodata']}>输入关键词查找</span>
      ) : (
        <Empty
          image={noDataPng}
          description="暂无数据"
          style={{ textAlign: 'center', color: '#9B9B9B' }}
          imageStyle={{ textAlign: 'center', marginTop: '14px' }}
        />
      );
    let hasMore = hasMoreContacts || hasMoreDepts || hasMoreGroups;
    const hasBreadcrumbNav =
      !sendSearchGlobal &&
      (activeKey === TabKeyType.Department ||
        activeKey === TabKeyType.WorkLine);
    //  const _newList = newList.filter(item => item.type !== TabKeyType.WorkLine);
    const _newList = newList;
    return (
      <>
        {/* 面包屑 */}
        {hasBreadcrumbNav && (
          <>
            <div className={styles['dept-crumb']}>{DepaBreadcrumbNav}</div>
            {isSendCheckAll && (
              <div className={styles['check-all']}>
                <CheckboxAll
                  preLen={_newList.length}
                  currentLen={currentLen}
                  onCheckAllChange={onCheckAllChange}
                ></CheckboxAll>
              </div>
            )}
          </>
        )}

        {!loading && !newList?.length
          ? noData
          : newList.map((item: any, index) => {
              const isDepartment =
                item?.type === TabKeyType.Department &&
                (activeKey === TabKeyType.Department ||
                  activeKey === TabKeyType.All);
              const isWorkLine =
                item?.type === TabKeyType.WorkLine &&
                (activeKey === TabKeyType.WorkLine ||
                  activeKey === TabKeyType.Department ||
                  activeKey === TabKeyType.All);
              const isShowRightIcon = isDepartment || isWorkLine;
              return (
                <div
                  key={item.id}
                  style={{ cursor: 'pointer' }}
                  onClick={event => {
                    if (isDepartment || isWorkLine) {
                      getDepaBreadcrumbNav(event, item.id, isWorkLine);
                    }
                  }}
                >
                  {activeKey === TabKeyType.All && (
                    <h4
                      className={styles['tab-all-typename']}
                      style={{ height: 'auto' }}
                    >
                      {item.typeName}
                    </h4>
                  )}
                  {activeKey === TabKeyType.Contact && item.pinyin && (
                    <div className={styles['tab-pinyin']}>{item.pinyin}</div>
                  )}
                  <Item
                    {...item}
                    callback={(_item: any) => {
                      onChange(_item);
                    }}
                    isShowRightIcon={isShowRightIcon}
                    isSelectUser={isSelectUser}
                    isHasGroups={isHasGroups}
                    activeKey={activeKey}
                  />
                  {activeKey === TabKeyType.All && item.hasMore && (
                    <div
                      className={styles['joyspace-list-more']}
                      onClick={event => {
                        event.stopPropagation();
                        event.nativeEvent.stopImmediatePropagation();
                        onChangeTab(
                          item?.type === TabKeyType.WorkLine
                            ? TabKeyType.Department
                            : item?.type
                        );
                      }}
                    >
                      <span>查询更多</span>
                      <RightOutlined />
                    </div>
                  )}
                </div>
              );
            })}
        {sendSearchGlobal &&
          activeKey !== TabKeyType.All &&
          newList.length > 0 &&
          !loading && (
            <div
              className={styles['joyspace-list-more']}
              onClick={() => {
                onButtom(activeKey, hasMore);
              }}
            >
              <span className={styles['joyspace-list-more-load']}>
                {hasMore ? '加载更多' : '已显示全部'}
              </span>
            </div>
          )}
      </>
    );
  }, [
    newList,
    activeKey,
    loading,
    hasMoreContacts,
    hasMoreDepts,
    hasMoreGroups,
    breadcrumbDepList,
  ]);
  return (
    <>
      {tabLoading && <Loading size={24}></Loading>}
      {!tabLoading && (
        <div className={styles['tab-container']} style={tabStyle}>
          <Tabs activeKey={activeKey} onChange={onChangeTab}>
            {tab &&
              tab.map((item: tabType) => {
                return (
                  <TabPane tab={item.title} key={item.key}>
                    <div
                      className={
                        sendSearchGlobal
                          ? styles['joyspace-tab-tabpane-global']
                          : styles['joyspace-tab-tabpane']
                      }
                    >
                      {TabMain}
                    </div>
                  </TabPane>
                );
              })}
          </Tabs>
        </div>
      )}
    </>
  );
}
